// extracted by mini-css-extract-plugin
export var lg = "_g2-4";
export var md = "_g2-3";
export var reactTimePickerInputGroupAmPm = "_g2-6";
export var redoTimePicker = "_g2-0";
export var sm = "_g2-2";
export var xl = "_g2-5";
export var xs = "_g2-1";